// extracted by mini-css-extract-plugin
export default {"wrapper":"gz-z","viewport":"hz-z","container":"iz-z","slide":"jz-z"};